/* eslint-disable react-hooks/exhaustive-deps */

import { Tag as BTag, Icon } from '@blueprintjs/core'
import { __ } from 'src/libs/utilities'
import IScalarForm from '../interface/IScalarForm'
import Scalar from './Scalar'
import { useEffect, useState } from 'react'
import { ID } from 'src/libs/interfaces/layouts'


const Enum = ( props: IScalarForm ): JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<EnumEnabled {...props} />}
        desabledForm={<EnumDisabled {...props} />}
    /> 
} 
export default Enum

const EnumDisabled = (props: IScalarForm) : JSX.Element => { 
    if(!Array.isArray(props.values)) return props.value.toString()
    const curr: any = props.values.filter((v:any) => v._id === props.value)[0]
    const v: string =  typeof curr === "undefined"
        ?
        props.value.toString()
        :
        curr.title
    return <BTag round className="px-4 py-1 m-1">{__(v)}</BTag>
}

const EnumEnabled = (props: IScalarForm) :JSX.Element => {
     
    const getSingleValue = () => {
        if( !props.value ) {

        } else {
            if( typeof (props.value ) === "object" ) {
                if( !!props.value?._id) {
                    return props.value
                }
                else if(!!props.value?.id) {
                    return {
                        ...props.value,
                        _id: props.value.id
                    }
                }
            }
            else {
                return { _id: props.value, title: props.value }
            }
        }
    }
    // console.log( props )
    const [value, setValue] = useState( () => {
        if(props.multiple)
        {
            let v =  Array.isArray(props.value) ? [ ...props.value ] : [] 
            return v
        }
        else
        {
            return getSingleValue()
        } 
    })
    useEffect( () => {
        setValue( () => {
            if(props.multiple)
            {
                let v =  Array.isArray(props.value) 
                    ? 
                    [ 
                        ...props.value
                    ] 
                    : 
                    [] 
                return v
            }
            else
            {
                return getSingleValue()
            } 
        })
        // console.log( props.value )
    }, [ props.value ] ) 
    const onClick = (id : ID) =>
    {
        // console.log( "onClick", id )
        setValue(id)
        if( props.onChange )
            props.onChange(id,  props.field, "" )
    }
    const onMultipleClick = (id : ID) =>
    {
        // console.log( "onMultipleClick", value)
        let vv
        if(value.filter((v: ID) => v === id ).length > 0)
        {
            vv = value.filter((v: ID) => v !== id )
        }
        else
        {
            vv = [...value]
            vv.push(id)
        }
        // setValue( vv )        
        if( props.onChange )
            props.onChange(vv,  props.field, "")
    }
    const onAll = () =>
    {
        let vv = value.length === props.values?.length 
            ? 
            [] 
            : 
            [ ...(props.values ? props.values?.map( v => v._id ? v._id : v ) : [] ) ]
        // setValue( vv )
        if( props.onChange )
            props.onChange(vv,  props.field, "")
    }
    const values = Array.isArray([ ...(props.values ? props.values : [] ) ])
        ?
        props.values?.map( (v, i) =>
        {
            return !props.multiple
                ?
                single({ v, value, i, onClick })
                :
                multiple({ 
                    v, 
                    value, 
                    i, 
                    onMultipleClick,
                    elementClassName:   props.elementClassName,
                    elementClassName2:  props.elementClassName2,
                })
        })
        :
        []
    
    return (
        <div className='w-100'>
            <div className='w-100 d-flex flex-wrap py-2 '> 
                { values } 
                {
                    props.multiple
                        ?
                        <BTag 
                            intent={"primary"} 
                            className={`m-1 ${props.elementClassName2 || "" } pointer`} 
                            minimal 
                            round
                            onClick={ onAll }
                            data-test-id="scalar-tags-all"
                        > 
                            { __( "All" ) }
                        </BTag>
                        :
                        null
                } 
            </div>
        </div>
        
    )
}


const multiple = (props: any) : JSX.Element | null =>
{
    const {v, value, i} = props
    // console.log( v, value, i )
    return  v?._id 
        ?
        <BTag 
            key={ v._id + "_" + i } 
            intent={ v.intent }
            role="checkbox"
            className={`m-1 pointer ${ props.elementClassName ? props.elementClassName : "px-3 py-1 maxw-450" }` }
            style={{backgroundColor: v.color}}
            round
            minimal={ !value.filter( (e: any) => e === v._id ).length}
            onClick={() => props.onMultipleClick( v._id )}
            data-testid="scalar-tags-multi"
        >
            <div className={ props.elementClassName2 || 'px-3' } dangerouslySetInnerHTML={{__html: v.title}} />
        </BTag>
        :
        typeof v === "string"
            ? 
            <BTag 
                key={v + "_" + i} 
                data-value={ v }  
                role="checkbox"
                className={`m-1 pointer ${ props.elementClassName ? props.elementClassName : "px-3 py-1 maxw-450" }`} 
                round
                minimal={ value.filter( (e: any) => e !== v ).length > 0 }
                onClick={() => props.onMultipleClick( v )}
                data-testid="scalar-tags-multi"
            >
                <div className={ props.elementClassName2 || 'px-3' } dangerouslySetInnerHTML={{__html: __(v) }} />
            </BTag> 
            :
            null
}
const single = (props: any): JSX.Element | null =>
{
    const {v, value, i} = props
    //console.log( value )
    return  v?._id 
        ?
        <BTag 
            key={ v._id + "_" + i } 
            intent={v.intent}
            data-hint={__(v.hint)}
            role="radio"
            className={`m-1 pr-3 py-1 ${v.disabled ? "opacity_75 hint hint--top " : ""} pointer`}
            style={{backgroundColor: v.color}} 
            round  
            minimal={ value?._id ? value._id !== v._id : value !== v._id }
            onClick={() => !v.disabled ? props.onClick(v._id) : null }
            data-testid="scalar-tags-single"
        >
            {
                v.disabled 
                    ? 
                    <div className='d-flex'>
                        <Icon icon="delete" intent="danger" className='pr-1'/>
                        <div className='opacity_5' dangerouslySetInnerHTML={{__html: __(v.title)}}/>
                    </div> 
                    : 
                    <div className='pl-3' dangerouslySetInnerHTML={{__html: __(v.title)}} /> 
                }
        </BTag>
        :
        typeof v === "string"
            ? 
            <BTag 
                key={v + "_" + i} 
                data-value={ v }
                role="radio"  
                className="m-1 px-3 py-1 pointer" 
                style={{ backgroundColor: value.color }}
                round
                minimal={ value !== v }
                onClick={() => props.onClick( v )}
                data-testid="scalar-tags-single"
            >
                { __(v) }
            </BTag> 
            :
            null
}